import { render, staticRenderFns } from "./InactivityModal.vue?vue&type=template&id=21a7e0b0&"
import script from "./InactivityModal.vue?vue&type=script&lang=js&"
export * from "./InactivityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports